export default __webpack_public_path__ + "static/media/active_plan.6c121a78.jpg";